// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.activity-log-body-container {
  display: flex;
  width: 100%;
  flex-direction: column;
  padding: 0 20px 20px 20px;
}
.activity-log-body-container h1 {
  margin-bottom: 20px;
}
.activity-log-body-container .activity-search {
  display: flex;
  justify-content: end;
  margin: 26px 0 2px 0;
}
.activity-log-body-container .activity-search .input-wrapper {
  width: unset !important;
}
.activity-log-body-container .tabulator {
  position: relative;
  background-color: #fff;
  font-size: 14px;
  text-align: left;
  margin-bottom: 20px;
  width: 100%;
}
.activity-log-body-container .tabulator .MuiTableCell-root.MuiTablePagination-root .MuiTablePagination-toolbar {
  background-color: #ebebeb !important;
  padding: 0 !important;
}
.activity-log-body-container .tabulator .ag-header-group-cell {
  font-family: "ABBVoice", sans-serif !important;
  font-size: 14px;
  font-weight: 500;
}
.activity-log-body-container .activity-log-filtering-container {
  display: flex;
  flex-direction: column;
  background: #fff;
  border-radius: 10px;
  padding: 10px 10px 15px 10px;
  margin-bottom: 15px;
}
.activity-log-body-container .activity-log-filtering-container .ag-header-container {
  background: #F5F5F5 !important;
}
.activity-log-body-container .activity-log-filtering-container .common-input {
  display: flex;
  padding: 12px;
  align-items: center;
  gap: 8px;
  flex: 1 0;
  border-radius: 6px;
  width: 280px;
  height: 40px;
}
.activity-log-body-container .activity-log-filtering-container .application-dropdown {
  width: 240px;
}
.activity-log-body-container .activity-log-filtering-container .filter-text-buttons-group-conatiner {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 5px;
  padding: 0 5px;
}
.activity-log-body-container .activity-log-filtering-container .filter-text-buttons-group-conatiner .filter-by-text .tag-filter-by-txt {
  border-radius: 16px;
  width: 100px;
  height: 30px;
  padding-top: 6px;
  background: var(--status-discreet-info, rgba(0, 81, 255, 0.08));
  color: var(--foreground-accent-primary, #000);
  font-family: ABBvoice;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 115%;
}
.activity-log-body-container .activity-log-filtering-container .filter-text-buttons-group-conatiner .filter-button {
  display: inline-flex;
  align-items: center;
  gap: 5px;
  min-width: 100px;
  border-radius: 20px;
}
.activity-log-body-container .activity-log-filtering-container .filter-text-buttons-group-conatiner .filter-button .filter-label {
  font-weight: 600;
  color: var(--sub-headings-color);
}
.activity-log-body-container .activity-log-filtering-container .filter-text-buttons-group-conatiner .export-button {
  display: inline-flex;
  height: 30px;
  justify-content: center;
  align-items: center;
  flex-shrink: 0;
  border-radius: 14px;
  border: 2px solid #36f;
  background: #fff;
}
.activity-log-body-container .activity-log-filtering-container .filter-text-buttons-group-conatiner .export-button:active {
  background-color: #36f !important;
  color: var(--foreground-white, #fff);
}
.activity-log-body-container .activity-log-filtering-container .filter-text-buttons-group-conatiner .export-button:hover {
  background-color: #dbdbdb;
  border: #dbdbdb;
}
.activity-log-body-container .activity-log-filtering-container .filter-text-buttons-group-conatiner .export-button .export-btn-txt {
  color: var(--foreground-primary, #1f1f1f);
  text-align: center;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 100%;
}
.activity-log-body-container .activity-log-filtering-container .filter-text-buttons-group-conatiner .export-dialog {
  height: 200px;
  width: 500px;
}
.activity-log-body-container .activity-log-filtering-container .filter-text-buttons-group-conatiner .export-dialog .activity-log-export-txt {
  margin-bottom: -21px;
}
.activity-log-body-container .activity-log-filtering-container .filter-text-buttons-group-conatiner .settings-button {
  height: 30px;
  justify-content: center;
  align-items: center;
  flex-shrink: 0;
  border-radius: 14px;
  border: 2px solid #36f;
  background: #fff;
  flex-wrap: wrap;
  color: var(--foreground-primary, #1f1f1f);
}
.activity-log-body-container .activity-log-filtering-container .filter-text-buttons-group-conatiner .settings-button:active {
  background-color: #36f !important;
  color: var(--foreground-white, #fff);
}
.activity-log-body-container .activity-log-filtering-container .filter-text-buttons-group-conatiner .settings-button:hover {
  background-color: #dbdbdb;
  border: #dbdbdb;
}
.activity-log-body-container .activity-log-filtering-container .application-row-conatiner {
  display: flex;
  flex-direction: row;
  margin-bottom: 30px;
  gap: 50px;
  padding: 0 5px;
}
.activity-log-body-container .activity-log-filtering-container .application-row-conatiner .label {
  margin-bottom: 4px;
  color: var(--foreground-primary, var(--sub-headings-color));
  font-family: ABBvoice;
  font-size: 12px;
  font-style: normal;
  font-weight: 600;
  line-height: 115%;
}
.activity-log-body-container .activity-log-filtering-container .user-row-conatiner {
  display: flex;
  flex-direction: row;
  gap: 50px;
  padding: 0 5px;
}
.activity-log-body-container .activity-log-filtering-container .user-row-conatiner .label {
  margin-bottom: 4px;
  color: var(--foreground-primary, var(--sub-headings-color));
  font-family: ABBvoice;
  font-size: 12px;
  font-style: normal;
  font-weight: 600;
  line-height: 115%;
}
.activity-log-body-container .activity-log-filtering-container .user-row-conatiner select {
  height: 40px;
  width: 280px;
}
.activity-log-body-container .activity-log-filtering-container .user-row-conatiner .btn-apply {
  display: flex;
  margin-left: auto;
  display: flex;
  width: 92px;
  height: 32px;
  justify-content: center;
  align-items: center;
  flex-shrink: 0;
  margin-top: 25px;
  margin-right: 0px;
}
.activity-log-body-container .search-bar {
  margin-left: auto;
  display: flex;
  width: 300px;
  margin-top: 30px;
  margin-bottom: 8px;
}
.activity-log-body-container .user-selection {
  display: flex;
  width: 280px;
}
.activity-log-body-container .css-15g569d-control {
  height: auto !important;
}
.activity-log-body-container .ABB_CommonUX_Dropdown__root > .ABB_CommonUX_Dropdown__comp {
  width: 280px;
}
.activity-log-body-container .export-btn {
  display: flex;
  margin: 10px 15px 10px auto;
  width: 90px;
}

.export-cancel-save-btn {
  display: flex;
  flex-direction: row;
  margin-bottom: 10px;
  width: 200px;
  justify-content: space-between;
  margin-left: auto;
  margin-top: auto;
}
.export-cancel-save-btn .btn-save {
  font-family: ABBVoice;
  font-size: small;
  border-radius: 18px;
  border: none;
  width: 92px;
  height: 31px;
  padding: 6px 0px;
  color: rgb(255, 255, 255);
  background: rgb(65, 104, 255);
  cursor: pointer;
}
.export-cancel-save-btn .btn-cancel {
  font-family: ABBVoice;
  font-size: small;
  border-radius: 18px;
  border: none;
  width: 92px;
  height: 31px;
  padding: 5px 0px rgb(255, 255, 255);
  border: 2px solid rgb(65, 104, 255);
  background-color: #fff;
  cursor: pointer;
}
.export-cancel-save-btn .btn-cancel:hover {
  background-color: #dbdbdb;
  border: #dbdbdb;
}
.export-cancel-save-btn .ABB_CommonUX_Button__root.ABB_CommonUX_Button__light.ABB_CommonUX_Button__primaryblue {
  background-color: #36f;
  border: 2px solid #36f;
  color: #fff;
}
.export-cancel-save-btn .ABB_CommonUX_ToggleButton__root.ABB_CommonUX_ToggleButton__light {
  margin-bottom: 6px;
}

.settings-dialog {
  height: 250px;
  width: 500px;
  flex-shrink: 0;
  display: flex;
  flex-direction: column;
  padding-left: -10px;
}
.settings-dialog .ABB_CommonUX_ToggleButton__root.ABB_CommonUX_ToggleButton__light {
  margin-bottom: 3px;
}
.settings-dialog .ABB_CommonUX_ToggleButtonGroup__container {
  margin-top: 16px;
}
.settings-dialog .settings-heading {
  position: relative;
  margin-bottom: -8px;
  color: var(--dialogue-text-color);
  font-size: 20px;
  display: flex;
  align-items: center;
  height: 46px;
}
.settings-dialog .settings-heading::before {
  position: absolute;
  content: "";
  width: 40px;
  height: 5px;
  background-color: #f01;
  bottom: 40px;
}
.settings-dialog .retention-period-txt {
  margin-top: 20px;
}

.export-dialog {
  height: 170px;
  width: 500px;
}
.export-dialog .activity-log-export-txt {
  position: relative;
}
.export-dialog .activity-log-export-txt::before {
  position: absolute;
  content: "";
  width: 40px;
  height: 5px;
  background-color: #f01;
  bottom: 28px;
}

span.ABB_CommonUX_Button__text.ABB_CommonUX_Button__hasText.ABB_CommonUX_Button__hasIcon {
  font-size: 16px;
}

.ABB_CommonUX_Dialog__root.ABB_CommonUX_Dialog__light {
  border-top: none !important;
}

.activity-log-user {
  width: 290px;
}

.filter-by {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 4px;
  border-radius: 16px;
  background: rgba(0, 81, 255, 0.08);
  height: 28px;
  width: 98px;
}

.filter-by img {
  height: 16px;
}

.filter-by h4 {
  margin: 0;
  font-size: 14px;
  line-height: 1;
  font-family: ABBvoice;
  font-style: normal;
  font-weight: 400;
}

.button-apply {
  margin-left: auto;
  margin-top: 9px;
}

.ABB_CommonUX_Button__root.ABB_CommonUX_Button__light.ABB_CommonUX_Button__ghost {
  background-color: var(--btn-background-color) !important;
  border: 2px solid #1f1f1f;
  color: #1f1f1f;
}

:where(.css-dev-only-do-not-override-m4timi).ant-picker-outlined {
  background: var(--input-field-color) !important;
  border-width: 1px;
  border-style: solid;
  border-color: #d9d9d9;
}

:where(.css-dev-only-do-not-override-m4timi).ant-picker .ant-picker-suffix {
  display: flex;
  flex: none;
  align-self: center;
  margin-inline-start: 4px;
  color: var(--icon-color) !important;
  line-height: 1;
  pointer-events: none;
  transition: opacity 0.2s, color 0.2s;
}

:where(.css-dev-only-do-not-override-m4timi).ant-picker .ant-picker-input > input {
  position: relative;
  display: inline-block;
  width: 100%;
  color: var(--text-primary-color) !important;
  font-size: 14px;
  line-height: 1.5714285714;
  transition: all 0.2s;
  flex: auto;
  min-width: 1px;
  height: auto;
  padding: 0;
  background: transparent;
  border: 0;
  font-family: inherit;
}

.ag-header,
.ag-advanced-filter-header {
  background-color: var(--table-header-color) !important;
  border-bottom: var(--ag-borders-critical) var(--ag-border-color);
}

.activity-log-body-container .tabulator .MuiTableCell-root.MuiTablePagination-root .MuiTablePagination-toolbar {
  background-color: var(--pagination-background-color) !important;
  padding: 0 15px !important;
}

.ABB_CommonUX_Dialog__root.ABB_CommonUX_Dialog__light {
  background: var(--dialogue-box-background-color) !important;
  border-top: 4px solid #0f0f0f;
  box-shadow: 0 6px 12px rgba(0, 0, 0, 0.35);
  color: var(--dialogue-text-color) !important;
}

.ABB_CommonUX_IconButton__root.ABB_CommonUX_IconButton__light {
  color: var(--dialogue-icon-color) !important;
}

.ABB_CommonUX_ToggleButton__root.ABB_CommonUX_ToggleButton__light {
  background: var(--dialogue-box-button-color) !important;
  border: 1px solid #9f9f9f;
  color: #0f0f0f;
}

.ABB_CommonUX_ToggleButton__root.ABB_CommonUX_ToggleButton__light {
  background: var(--main-background-color) !important;
  border: 1px solid #9f9f9f;
  color: #0f0f0f;
}`, "",{"version":3,"sources":["webpack://./src/assets/styles/activitylog.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,WAAA;EACA,sBAAA;EACA,yBAAA;AACF;AACE;EACE,mBAAA;AACJ;AAEE;EACE,aAAA;EACA,oBAAA;EACA,oBAAA;AAAJ;AAEI;EACE,uBAAA;AAAN;AAIE;EACE,kBAAA;EACA,sBAAA;EACA,eAAA;EACA,gBAAA;EACA,mBAAA;EACA,WAAA;AAFJ;AAII;EACE,oCAAA;EACA,qBAAA;AAFN;AAKI;EACE,8CAAA;EACA,eAAA;EACA,gBAAA;AAHN;AAOE;EACE,aAAA;EACA,sBAAA;EACA,gBAAA;EACA,mBAAA;EACA,4BAAA;EACA,mBAAA;AALJ;AAOI;EACE,8BAAA;AALN;AAQI;EACE,aAAA;EACA,aAAA;EACA,mBAAA;EACA,QAAA;EACA,SAAA;EACA,kBAAA;EACA,YAAA;EACA,YAAA;AANN;AASI;EACE,YAAA;AAPN;AAUI;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,mBAAA;EACA,kBAAA;EACA,cAAA;AARN;AAWQ;EACE,mBAAA;EACA,YAAA;EACA,YAAA;EACA,gBAAA;EACA,+DAAA;EACA,6CAAA;EACA,qBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;AATV;AAaM;EACE,oBAAA;EACA,mBAAA;EACA,QAAA;EACA,gBAAA;EACA,mBAAA;AAXR;AAaQ;EACE,gBAAA;EACA,gCAAA;AAXV;AAeM;EACE,oBAAA;EACA,YAAA;EACA,uBAAA;EACA,mBAAA;EACA,cAAA;EACA,mBAAA;EACA,sBAAA;EACA,gBAAA;AAbR;AAeQ;EACE,iCAAA;EACA,oCAAA;AAbV;AAgBQ;EACE,yBAAA;EACA,eAAA;AAdV;AAiBQ;EACE,yCAAA;EACA,kBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;AAfV;AAmBM;EACE,aAAA;EACA,YAAA;AAjBR;AAmBQ;EACE,oBAAA;AAjBV;AAqBM;EACE,YAAA;EACA,uBAAA;EACA,mBAAA;EACA,cAAA;EACA,mBAAA;EACA,sBAAA;EACA,gBAAA;EACA,eAAA;EACA,yCAAA;AAnBR;AAqBQ;EACE,iCAAA;EACA,oCAAA;AAnBV;AAsBQ;EACE,yBAAA;EACA,eAAA;AApBV;AAyBI;EACE,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,SAAA;EACA,cAAA;AAvBN;AAyBM;EACE,kBAAA;EACA,2DAAA;EACA,qBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;AAvBR;AA2BI;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,cAAA;AAzBN;AA2BM;EACE,kBAAA;EACA,2DAAA;EACA,qBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;AAzBR;AA4BM;EACE,YAAA;EACA,YAAA;AA1BR;AA6BM;EACE,aAAA;EACA,iBAAA;EACA,aAAA;EACA,WAAA;EACA,YAAA;EACA,uBAAA;EACA,mBAAA;EACA,cAAA;EACA,gBAAA;EACA,iBAAA;AA3BR;AAgCE;EACE,iBAAA;EACA,aAAA;EACA,YAAA;EACA,gBAAA;EACA,kBAAA;AA9BJ;AAiCE;EACE,aAAA;EACA,YAAA;AA/BJ;AAkCE;EACE,uBAAA;AAhCJ;AAmCE;EACE,YAAA;AAjCJ;AAoCE;EACE,aAAA;EACA,2BAAA;EACA,WAAA;AAlCJ;;AAsCA;EACE,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,YAAA;EACA,8BAAA;EACA,iBAAA;EACA,gBAAA;AAnCF;AAqCE;EACE,qBAAA;EACA,gBAAA;EACA,mBAAA;EACA,YAAA;EACA,WAAA;EACA,YAAA;EACA,gBAAA;EACA,yBAAA;EACA,6BAAA;EACA,eAAA;AAnCJ;AAsCE;EACE,qBAAA;EACA,gBAAA;EACA,mBAAA;EACA,YAAA;EACA,WAAA;EACA,YAAA;EACA,mCAAA;EACA,mCAAA;EACA,sBAAA;EACA,eAAA;AApCJ;AAsCI;EACE,yBAAA;EACA,eAAA;AApCN;AAwCE;EACE,sBAAA;EACA,sBAAA;EACA,WAAA;AAtCJ;AAyCE;EACE,kBAAA;AAvCJ;;AA2CA;EACE,aAAA;EACA,YAAA;EACA,cAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;AAxCF;AA0CE;EACE,kBAAA;AAxCJ;AA2CE;EACE,gBAAA;AAzCJ;AA4CE;EACE,kBAAA;EACA,mBAAA;EACA,iCAAA;EACA,eAAA;EACA,aAAA;EACA,mBAAA;EACA,YAAA;AA1CJ;AA4CI;EACE,kBAAA;EACA,WAAA;EACA,WAAA;EACA,WAAA;EACA,sBAAA;EACA,YAAA;AA1CN;AA8CE;EACE,gBAAA;AA5CJ;;AAgDA;EACE,aAAA;EACA,YAAA;AA7CF;AA+CE;EACE,kBAAA;AA7CJ;AA+CI;EACE,kBAAA;EACA,WAAA;EACA,WAAA;EACA,WAAA;EACA,sBAAA;EACA,YAAA;AA7CN;;AAkDA;EACE,eAAA;AA/CF;;AAkDA;EACE,2BAAA;AA/CF;;AAkDA;EACE,YAAA;AA/CF;;AAkDA;EACE,oBAAA;EACA,mBAAA;EACA,QAAA;EACA,YAAA;EACA,mBAAA;EACA,kCAAA;EACA,YAAA;EACA,WAAA;AA/CF;;AAkDA;EACE,YAAA;AA/CF;;AAkDA;EACE,SAAA;EACA,eAAA;EACA,cAAA;EACA,qBAAA;EACA,kBAAA;EACA,gBAAA;AA/CF;;AAkDA;EACE,iBAAA;EACA,eAAA;AA/CF;;AAkDA;EACE,wDAAA;EACA,yBAAA;EACA,cAAA;AA/CF;;AAkDA;EACE,+CAAA;EACA,iBAAA;EACA,mBAAA;EACA,qBAAA;AA/CF;;AAkDA;EACE,aAAA;EACA,UAAA;EACA,kBAAA;EACA,wBAAA;EACA,mCAAA;EACA,cAAA;EACA,oBAAA;EACA,oCAAA;AA/CF;;AAkDA;EACE,kBAAA;EACA,qBAAA;EACA,WAAA;EACA,2CAAA;EACA,eAAA;EACA,yBAAA;EACA,oBAAA;EACA,UAAA;EACA,cAAA;EACA,YAAA;EACA,UAAA;EACA,uBAAA;EACA,SAAA;EACA,oBAAA;AA/CF;;AAyDA;;EAEE,sDAAA;EACA,gEAAA;AAtDF;;AAyDA;EACE,+DAAA;EACA,0BAAA;AAtDF;;AAyDA;EACE,2DAAA;EACA,6BAAA;EACA,0CAAA;EACA,4CAAA;AAtDF;;AAyDA;EACE,4CAAA;AAtDF;;AAyDA;EACE,uDAAA;EACA,yBAAA;EACA,cAAA;AAtDF;;AAyDA;EACE,mDAAA;EACA,yBAAA;EACA,cAAA;AAtDF","sourcesContent":[".activity-log-body-container {\n  display: flex;\n  width: 100%;\n  flex-direction: column;\n  padding: 0 20px 20px 20px;\n\n  h1 {\n    margin-bottom: 20px;\n  }\n\n  .activity-search {\n    display: flex;\n    justify-content: end;\n    margin: 26px 0 2px 0;\n\n    .input-wrapper {\n      width: unset !important;\n    }\n  }\n\n  .tabulator {\n    position: relative;\n    background-color: #fff;\n    font-size: 14px;\n    text-align: left;\n    margin-bottom: 20px;\n    width: 100%;\n\n    .MuiTableCell-root.MuiTablePagination-root .MuiTablePagination-toolbar {\n      background-color: #ebebeb !important;\n      padding: 0 !important;\n    }\n\n    .ag-header-group-cell {\n      font-family: \"ABBVoice\", sans-serif !important;\n      font-size: 14px;\n      font-weight: 500;\n    }\n  }\n\n  .activity-log-filtering-container {\n    display: flex;\n    flex-direction: column;\n    background: #fff;\n    border-radius: 10px;\n    padding: 10px 10px 15px 10px;\n    margin-bottom: 15px;\n\n    .ag-header-container {\n      background: #F5F5F5 !important;\n    }\n\n    .common-input {\n      display: flex;\n      padding: 12px;\n      align-items: center;\n      gap: 8px;\n      flex: 1 0 0;\n      border-radius: 6px;\n      width: 280px;\n      height: 40px;\n    }\n\n    .application-dropdown {\n      width: 240px;\n    }\n\n    .filter-text-buttons-group-conatiner {\n      display: flex;\n      flex-direction: row;\n      justify-content: space-between;\n      align-items: center;\n      margin-bottom: 5px;\n      padding: 0 5px;\n\n      .filter-by-text {\n        .tag-filter-by-txt {\n          border-radius: 16px;\n          width: 100px;\n          height: 30px;\n          padding-top: 6px;\n          background: var(--status-discreet-info, rgba(0, 81, 255, 0.08));\n          color: var(--foreground-accent-primary, #000);\n          font-family: ABBvoice;\n          font-size: 14px;\n          font-style: normal;\n          font-weight: 400;\n          line-height: 115%;\n        }\n      }\n\n      .filter-button {\n        display: inline-flex;\n        align-items: center;\n        gap: 5px;\n        min-width: 100px;\n        border-radius: 20px;\n\n        .filter-label {\n          font-weight: 600;\n          color: var(--sub-headings-color);\n        }\n      }\n\n      .export-button {\n        display: inline-flex;\n        height: 30px;\n        justify-content: center;\n        align-items: center;\n        flex-shrink: 0;\n        border-radius: 14px;\n        border: 2px solid #36f;\n        background: #fff;\n\n        &:active {\n          background-color: #36f !important;\n          color: var(--foreground-white, #fff);\n        }\n\n        &:hover {\n          background-color: #dbdbdb;\n          border: #dbdbdb;\n        }\n\n        .export-btn-txt {\n          color: var(--foreground-primary, #1f1f1f);\n          text-align: center;\n          font-size: 14px;\n          font-style: normal;\n          font-weight: 500;\n          line-height: 100%;\n        }\n      }\n\n      .export-dialog {\n        height: 200px;\n        width: 500px;\n\n        .activity-log-export-txt {\n          margin-bottom: -21px;\n        }\n      }\n\n      .settings-button {\n        height: 30px;\n        justify-content: center;\n        align-items: center;\n        flex-shrink: 0;\n        border-radius: 14px;\n        border: 2px solid #36f;\n        background: #fff;\n        flex-wrap: wrap;\n        color: var(--foreground-primary, #1f1f1f);\n\n        &:active {\n          background-color: #36f !important;\n          color: var(--foreground-white, #fff);\n        }\n\n        &:hover {\n          background-color: #dbdbdb;\n          border: #dbdbdb;\n        }\n      }\n    }\n\n    .application-row-conatiner {\n      display: flex;\n      flex-direction: row;\n      margin-bottom: 30px;\n      gap: 50px;\n      padding: 0 5px;\n\n      .label {\n        margin-bottom: 4px;\n        color: var(--foreground-primary, var(--sub-headings-color));\n        font-family: ABBvoice;\n        font-size: 12px;\n        font-style: normal;\n        font-weight: 600;\n        line-height: 115%;\n      }\n    }\n\n    .user-row-conatiner {\n      display: flex;\n      flex-direction: row;\n      gap: 50px;\n      padding: 0 5px;\n\n      .label {\n        margin-bottom: 4px;\n        color: var(--foreground-primary, var(--sub-headings-color));\n        font-family: ABBvoice;\n        font-size: 12px;\n        font-style: normal;\n        font-weight: 600;\n        line-height: 115%;\n      }\n\n      select {\n        height: 40px;\n        width: 280px;\n      }\n\n      .btn-apply {\n        display: flex;\n        margin-left: auto;\n        display: flex;\n        width: 92px;\n        height: 32px;\n        justify-content: center;\n        align-items: center;\n        flex-shrink: 0;\n        margin-top: 25px;\n        margin-right: 0px;\n      }\n    }\n  }\n\n  .search-bar {\n    margin-left: auto;\n    display: flex;\n    width: 300px;\n    margin-top: 30px;\n    margin-bottom: 8px;\n  }\n\n  .user-selection {\n    display: flex;\n    width: 280px;\n  }\n\n  .css-15g569d-control {\n    height: auto !important;\n  }\n\n  .ABB_CommonUX_Dropdown__root>.ABB_CommonUX_Dropdown__comp {\n    width: 280px;\n  }\n\n  .export-btn {\n    display: flex;\n    margin: 10px 15px 10px auto;\n    width: 90px;\n  }\n}\n\n.export-cancel-save-btn {\n  display: flex;\n  flex-direction: row;\n  margin-bottom: 10px;\n  width: 200px;\n  justify-content: space-between;\n  margin-left: auto;\n  margin-top: auto;\n\n  .btn-save {\n    font-family: ABBVoice;\n    font-size: small;\n    border-radius: 18px;\n    border: none;\n    width: 92px;\n    height: 31px;\n    padding: 6px 0px;\n    color: rgb(255, 255, 255);\n    background: rgb(65, 104, 255);\n    cursor: pointer;\n  }\n\n  .btn-cancel {\n    font-family: ABBVoice;\n    font-size: small;\n    border-radius: 18px;\n    border: none;\n    width: 92px;\n    height: 31px;\n    padding: 5px 0px rgb(255, 255, 255);\n    border: 2px solid rgb(65, 104, 255);\n    background-color: #fff;\n    cursor: pointer;\n\n    &:hover {\n      background-color: #dbdbdb;\n      border: #dbdbdb;\n    }\n  }\n\n  .ABB_CommonUX_Button__root.ABB_CommonUX_Button__light.ABB_CommonUX_Button__primaryblue {\n    background-color: #36f;\n    border: 2px solid #36f;\n    color: #fff;\n  }\n\n  .ABB_CommonUX_ToggleButton__root.ABB_CommonUX_ToggleButton__light {\n    margin-bottom: 6px;\n  }\n}\n\n.settings-dialog {\n  height: 250px;\n  width: 500px;\n  flex-shrink: 0;\n  display: flex;\n  flex-direction: column;\n  padding-left: -10px;\n\n  .ABB_CommonUX_ToggleButton__root.ABB_CommonUX_ToggleButton__light {\n    margin-bottom: 3px;\n  }\n\n  .ABB_CommonUX_ToggleButtonGroup__container {\n    margin-top: 16px;\n  }\n\n  .settings-heading {\n    position: relative;\n    margin-bottom: -8px;\n    color: var(--dialogue-text-color);\n    font-size: 20px;\n    display: flex;\n    align-items: center;\n    height: 46px;\n\n    &::before {\n      position: absolute;\n      content: \"\";\n      width: 40px;\n      height: 5px;\n      background-color: #f01;\n      bottom: 40px;\n    }\n  }\n\n  .retention-period-txt {\n    margin-top: 20px;\n  }\n}\n\n.export-dialog {\n  height: 170px;\n  width: 500px;\n\n  .activity-log-export-txt {\n    position: relative;\n\n    &::before {\n      position: absolute;\n      content: \"\";\n      width: 40px;\n      height: 5px;\n      background-color: #f01;\n      bottom: 28px;\n    }\n  }\n}\n\nspan.ABB_CommonUX_Button__text.ABB_CommonUX_Button__hasText.ABB_CommonUX_Button__hasIcon {\n  font-size: 16px;\n}\n\n.ABB_CommonUX_Dialog__root.ABB_CommonUX_Dialog__light {\n  border-top: none !important;\n}\n\n.activity-log-user {\n  width: 290px;\n}\n\n.filter-by {\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  padding: 4px;\n  border-radius: 16px;\n  background: rgba(0, 81, 255, 0.08);\n  height: 28px;\n  width: 98px;\n}\n\n.filter-by img {\n  height: 16px;\n}\n\n.filter-by h4 {\n  margin: 0;\n  font-size: 14px;\n  line-height: 1;\n  font-family: ABBvoice;\n  font-style: normal;\n  font-weight: 400;\n}\n\n.button-apply {\n  margin-left: auto;\n  margin-top: 9px;\n}\n\n.ABB_CommonUX_Button__root.ABB_CommonUX_Button__light.ABB_CommonUX_Button__ghost {\n  background-color: var(--btn-background-color) !important;\n  border: 2px solid #1f1f1f;\n  color: #1f1f1f;\n}\n\n:where(.css-dev-only-do-not-override-m4timi).ant-picker-outlined {\n  background: var(--input-field-color) !important;\n  border-width: 1px;\n  border-style: solid;\n  border-color: #d9d9d9;\n}\n\n:where(.css-dev-only-do-not-override-m4timi).ant-picker .ant-picker-suffix {\n  display: flex;\n  flex: none;\n  align-self: center;\n  margin-inline-start: 4px;\n  color: var(--icon-color) !important;\n  line-height: 1;\n  pointer-events: none;\n  transition: opacity 0.2s, color 0.2s;\n}\n\n:where(.css-dev-only-do-not-override-m4timi).ant-picker .ant-picker-input>input {\n  position: relative;\n  display: inline-block;\n  width: 100%;\n  color: var(--text-primary-color) !important;\n  font-size: 14px;\n  line-height: 1.5714285714285714;\n  transition: all 0.2s;\n  flex: auto;\n  min-width: 1px;\n  height: auto;\n  padding: 0;\n  background: transparent;\n  border: 0;\n  font-family: inherit;\n}\n\n// .ag-theme-quartz, .ag-theme-quartz-dark, .ag-theme-quartz-auto-dark {\n//   --ag-active-color: #2196f3;\n//   --ag-background-color: var(--ag-background-color)!important;\n//   --ag-foreground-color: #fff!important;\n\n// }\n\n.ag-header,\n.ag-advanced-filter-header {\n  background-color: var(--table-header-color) !important;\n  border-bottom: var(--ag-borders-critical) var(--ag-border-color);\n}\n\n.activity-log-body-container .tabulator .MuiTableCell-root.MuiTablePagination-root .MuiTablePagination-toolbar {\n  background-color: var(--pagination-background-color) !important;\n  padding: 0 15px !important;\n}\n\n.ABB_CommonUX_Dialog__root.ABB_CommonUX_Dialog__light {\n  background: var(--dialogue-box-background-color) !important;\n  border-top: 4px solid #0f0f0f;\n  box-shadow: 0 6px 12px rgba(0, 0, 0, .35);\n  color: var(--dialogue-text-color) !important;\n}\n\n.ABB_CommonUX_IconButton__root.ABB_CommonUX_IconButton__light {\n  color: var(--dialogue-icon-color) !important;\n}\n\n.ABB_CommonUX_ToggleButton__root.ABB_CommonUX_ToggleButton__light {\n  background: var(--dialogue-box-button-color) !important;\n  border: 1px solid #9f9f9f;\n  color: #0f0f0f;\n}\n\n.ABB_CommonUX_ToggleButton__root.ABB_CommonUX_ToggleButton__light {\n  background: var(--main-background-color) !important;\n  border: 1px solid #9f9f9f;\n  color: #0f0f0f;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
